import { AdminGuard } from '@/components/admin-guard'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'
import { KbEditor } from '@/features/kb/KbEditor'
import { useCreateKbArticle } from '@/queries/kb'

function NewArticle() {
  const navigate = useNavigate()
  const create = useCreateKbArticle()

  return (
    <KbEditor
      saving={create.isPending}
      onSave={async values => {
        try {
          const article = await create.mutateAsync(values)
          toast.success('Article created')
          navigate({ to: `/admin/kb/${article._id}` as never })
        } catch (err) {
          toast.error((err as Error).message ?? 'Could not create article')
        }
      }}
    />
  )
}

export const Route = createFileRoute('/admin/kb/new')({ component: () => (
    <AdminGuard>
      <NewArticle />
    </AdminGuard>
  ) })
